import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
    UncontrolledTooltip,
} from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import { toast } from "react-toastify";

export const AdministratorModal = ({
    modalOpen,
    formData,
    isPasswordEdit,
    handleChange,
    closeModal,
}) => {
    const { postData, patchData, invalidateQuery } = useDataFetch();

    const { mutateAsync: createAdmin } = postData("/administrators", {}, {
        onSuccess: (response) => {
            if (response.message === "admin_create_success") {
                toast.success("Administrador creado correctamente");
                invalidateQuery(["administrators"]);
                closeModal();
            }
        },
    });

    const { mutateAsync: updateAdmin } = patchData("/administrators/update/admin", {}, {
        onSuccess: (response) => {
            if (response.message === "admin_update_by_id_success") {
                toast.success("Administrador actualizado correctamente");
                invalidateQuery(["administrators"]);
                closeModal();
            }
        },
    });

    const { mutateAsync: updatePassword } = patchData("/administrators/update/password", {}, {
        onSuccess: (response) => {
            if (response.message === "admin_update_password_success") {
                toast.success("Contraseña actualizada correctamente");
                invalidateQuery(["administrators"]);
                closeModal();
            }
        },
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.id && isPasswordEdit) {
            await updatePassword({ id: formData.id, password: formData.password });
        } else if (formData.id) {
            const { password, ...dataToUpdate } = formData;
            await updateAdmin(dataToUpdate);
        } else {
            await createAdmin(formData);
        }

        closeModal();
    };
    return (
        <Modal isOpen={modalOpen} backdrop="static" keyboard={false}>
            <ModalHeader toggle={closeModal}>
                {formData.id
                    ? isPasswordEdit
                        ? "Cambiar Contraseña"
                        : "Editar Administrador"
                    : "Registrar Administrador"}
            </ModalHeader>

            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    {!isPasswordEdit && (
                        <>
                            <FormGroup>
                                <Label>Nombre</Label>
                                <Input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Correo</Label>
                                <Input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Rol</Label>
                                <Input
                                    type="select"
                                    name="role"
                                    value={formData.role}
                                    onChange={handleChange}
                                >
                                    <option value="ADMIN">Administrador</option>
                                    <option value="ADMIN_ASSISTANT">Auxiliar Administrativo</option>
                                    <option value="ASSISTANT">Auxiliar</option>
                                </Input>
                            </FormGroup>
                        </>
                    )}

                    {(isPasswordEdit || !formData.id) && (
                        <FormGroup>
                            <Label>Contraseña</Label>
                            <Input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder={
                                    formData.id && isPasswordEdit ? "Nueva contraseña" : ""
                                }
                                required={!formData.id || isPasswordEdit}
                            />
                        </FormGroup>
                    )}

                    <ModalFooter>
                        <Btn
                            attrBtn={{
                                color: "secondary",
                                onClick: closeModal,
                                id: "cancel-btn",
                            }}
                        >
                            <i className="fa fa-times" />
                        </Btn>
                        <UncontrolledTooltip target="cancel-btn">Cancelar</UncontrolledTooltip>

                        <Btn
                            attrBtn={{
                                color: "primary",
                                type: "submit",
                                id: "save-btn",
                            }}
                        >
                            <i className="fa fa-save" />
                        </Btn>
                        <UncontrolledTooltip target="save-btn">Guardar</UncontrolledTooltip>
                    </ModalFooter>
                </Form>
            </ModalBody>
        </Modal>
    );
};
